/**
 * @flow
 * @format
 */

import _GraphGroup from './GraphGroup';

export default _GraphGroup;



// WEBPACK FOOTER //
// ./src/components/GraphGroup/index.js